import { render } from "./Hue.vue?vue&type=template&id=1766620e&scoped=true&ts=true"
import script from "./Hue.vue?vue&type=script&lang=ts"
export * from "./Hue.vue?vue&type=script&lang=ts"

import "./Hue.vue?vue&type=style&index=0&id=1766620e&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1766620e"]])

export default __exports__